import axios from "axios";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";

const API_NAME = "schoolBooking";

export const schoolBookingService = {
    getAllBookedDates,
    getCustomerBooking,
    cancelCustomerBooking,
    uploadVcfFile,
    getCosts
};

function getAllBookedDates() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAllBookedDates`, requestOptions).then(handleResponse);
}

function getCustomerBooking(token: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetCustomerBooking/?token=${token}`, requestOptions).then(handleResponse);
}

function cancelCustomerBooking(id: any, cancellationReason: string) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/CancelCustomerBooking/?bookingId=${id}&cancellationReason=${cancellationReason}`, requestOptions).then(handleResponse);
}

function uploadVcfFile(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.post(`${API_URL}/${API_NAME}/UploadVcfFile`, model, config);
}

function getCosts(formId:any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetCosts/?formId=${formId}`, requestOptions).then(handleResponse);
}
